const href = document?.location?.href;

if (href) {
  const urlParams = new URL(href).searchParams;
  const xuid = urlParams.get('adm_adtr_xuid');

  if (xuid) {
    var formData = new FormData();
    formData.append("attributes[moppy_xuid]", xuid);
    formData.append("attributes[moppy_xuid_set_at]", Date.now());

    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
    })
  }
}
